import React from "react"

function CallToAction() {
  return (
    <div className="row" id="cta">
      <div className="col-lg-6 text-title">
        <h1 className="big-heading">Ready...</h1>
        <h2>npm install black-women-inspire</h2>
        <a
          href="https://www.npmjs.com/package/black-women-inspire"
          target="_blank"
          rel="noreferrer"
        >
          <button type="button" className="btn btn-dark btn-lg download-button">
            📦 Download
          </button>
        </a>
        <a
          href="https://github.com/BennettElisa/black-women-inspire#readme"
          target="_blank"
          rel="noreferrer"
        >
          <button className="btn btn-dark btn-lg download-button" type="button">
            📄 GitHub Repo
          </button>
        </a>
      </div>
      <div className="col-lg-6"></div>
    </div>
  )
}

export default CallToAction
